import { LOCALE_ID, NgModule } from '@angular/core';
import { CommonModule, registerLocaleData } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatRadioModule } from '@angular/material/radio';
import { MatChipsModule } from '@angular/material/chips';
import { MAT_DATE_LOCALE } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatSelectModule } from '@angular/material/select';
import { MatTreeModule } from '@angular/material/tree';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSliderModule } from '@angular/material/slider';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatSortModule } from '@angular/material/sort';
import { MatStepperModule } from '@angular/material/stepper';
import { MatTableModule } from '@angular/material/table';
import { MAT_TABS_CONFIG, MatTabsModule } from '@angular/material/tabs';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatListModule } from '@angular/material/list';
import { MatCardModule } from '@angular/material/card';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTableExporterModule } from '@csmart/mat-table-exporter';

import { MatBadgeModule } from '@angular/material/badge';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatSidenavModule } from '@angular/material/sidenav';

import { provideCalendarDayDateAdapter } from '@core/services/calendar-day-date-adapter';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';

import { EditorModule } from '@tinymce/tinymce-angular';
import { PortalModule } from '@angular/cdk/portal';

import localeDa from '@angular/common/locales/da';

// Register the Danish locale data
registerLocaleData(localeDa);

@NgModule({
  declarations: [],

  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    PortalModule,
    // material
    MatIconModule,
    MatDialogModule,
    MatSnackBarModule,
    ReactiveFormsModule,
    MatDatepickerModule,
    MatSelectModule,
    MatSidenavModule,
    MatExpansionModule,
    MatToolbarModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    MatTableExporterModule,
  ],
  exports: [
    // Re-export these modules to prevent repeated imports (see: https://angular.io/guide/ngmodule#re-exporting-other-modules)
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    // material
    MatTableModule,
    MatTabsModule,
    MatPaginatorModule,
    MatSortModule,
    MatToolbarModule,
    MatMenuModule,
    MatButtonModule,
    MatDatepickerModule,
    MatFormFieldModule,
    MatProgressBarModule,
    MatCheckboxModule,
    MatRadioModule,
    MatInputModule,
    MatChipsModule,
    MatSelectModule,
    MatSidenavModule,
    MatStepperModule,
    MatTooltipModule,
    MatAutocompleteModule,
    MatButtonToggleModule,
    MatSlideToggleModule,
    MatDialogModule,
    MatSnackBarModule,
    MatSliderModule,
    MatIconModule,
    MatExpansionModule,
    MatBadgeModule,
    MatListModule,
    MatCardModule,
    MatProgressSpinnerModule, // needed to use the MatIconRegistry to register our own icons
    NgxSkeletonLoaderModule,
    EditorModule,
    MatTreeModule,
    MatTableExporterModule,
  ],
  providers: [
    // Datepickers speak CalendarDay ('YYYY-MM-DD'), not Date — see calendar-day-date-adapter.ts.
    // MatNativeDateModule is deliberately absent from the imports above: it exists to provide
    // NativeDateAdapter and MAT_NATIVE_DATE_FORMATS, and both are replaced here.
    //
    // Moves to app.config.ts's providers as one line when this module goes away.
    ...provideCalendarDayDateAdapter(),
    // { provide: MAT_FORM_FIELD_DEFAULT_OPTIONS, useValue: { appearance: 'outline' } },
    { provide: MAT_TABS_CONFIG, useValue: { stretchTabs: false } },
    { provide: MAT_DATE_LOCALE, useValue: 'da-DK' },
    { provide: LOCALE_ID, useValue: 'da-DK' },
  ],
})
export class SharedModule {}
